import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NastaveniUcetniJednotkaDataService } from '../nastaveni-ucetni-jednotka-data/nastaveni-ucetni-jednotky-data.service';
import { DetailService, Field, FormSettings } from '../shared/detail/detail.service';
import { ButtonInvoke } from '../shared/panel-buttons/panel-buttons.component';


export class NastaveniUcetniJednotkaFormSettings implements FormSettings {
  fieldsNew: Field[] = [];
  fieldsEdit: Field[] = [
    { name: 'sestavujeZvPpt', title: 'SestavujeZvPpt', type: 'string'},
    { name: 'sestavujeZvPrilohu', title: 'SestavujeZvPrilohu', type: 'string'},
    { name: 'sestavujeZvPzvk', title: 'SestavujeZvPzvk', type: 'string'}
  ];
}

@Injectable()
export class NastaveniUcetniJednotkaService extends DetailService
{
  override createToolbarButtons(): ButtonInvoke[]
  {
    let buttons: ButtonInvoke[] = [];
    buttons.push(new ButtonInvoke(this, 'Uložit', 'save', '<i class="cml-fw cml-lg cml-floppy-o"></i>', 'cml-active-green'));
    buttons.push(new ButtonInvoke(this, 'Detail', 'navigateToDetail', '<i class="cml-fw cml-lg cml-arrow-left"></i>', 'cml-active-black'));
    buttons.push(new ButtonInvoke(this, 'Zavřít', 'close', '<i class="cml-fw cml-lg cml-close"></i>', 'cml-active-black'));
    return buttons;
  }
  navigateToNastaveni()
  {
    this.router.navigateByUrl(this.router.url + '/nastaveni-ucetni-jednotky');
  }

  constructor(private NastaveniUcetniJednotkaDataService: NastaveniUcetniJednotkaDataService, private router: Router)
  {
    super(NastaveniUcetniJednotkaDataService, new NastaveniUcetniJednotkaFormSettings());
  }
}
